import { flow } from 'fp-ts/function';
import { __, concat, constant, get, isNil, join, nth, over } from 'lodash/fp';
import { cloneElement } from 'react';
import { ifElse, whenIsArray } from '@mews/fp';
import { flexDirectionHandler, indexHandler } from './handlers';

export const getFlexDirection = flow(get('vectorDirection'), flexDirectionHandler);

const appendPxString = flow(concat(__, 'px'), join(''));

const createPxOrDefaultGetter = (defaultString: string) => (propName: string) =>
    flow(get(propName), ifElse(isNil, constant(defaultString), appendPxString));

const createPxOrAutoGetter = createPxOrDefaultGetter('auto');
const createPxOr100PercentGetter = createPxOrDefaultGetter('100%');

export const getHeightInPxOrAuto = createPxOrAutoGetter('height');
export const getHeightInPxOr100Percent = createPxOr100PercentGetter('height');

export const getWidthInPxOrAuto = createPxOrAutoGetter('width');
export const getWidthInPxOr100Percent = createPxOr100PercentGetter('width');

const whenIsArrayGetByIndex = (index: $TSFixMe) => whenIsArray(nth(index));

export const renderOuterCell =
    ({ cellHeight, cellWidth, ...additionalProps }: $TSFixMe) =>
    (cell: $TSFixMe, cellIndex: $TSFixMe) => {
        const getCellDimension = whenIsArrayGetByIndex(cellIndex);
        return cloneElement(cell, {
            height: getCellDimension(cellHeight),
            width: getCellDimension(cellWidth),
            ...additionalProps,
        });
    };

export const createCellDimensionGetters = flow(
    indexHandler,
    over([flow(get('rowIndex'), whenIsArrayGetByIndex), flow(get('columnIndex'), whenIsArrayGetByIndex)])
);
